module.exports = __webpack_public_path__ + "static/media/onboardingFirst.95335956.jpeg";